/**
 * @fileoverview POST handler for the "/comments/:target/threads" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { mutationCacheKeys } from "./constants";
import type { AppendAppGroupToUrl, CreateCommentThreadProps, CreateCommentThreadResult } from "./types";

export const createCommentThread = reactQueryMutationAdapter(
  mutationCacheKeys,
  (props: AppendAppGroupToUrl<CreateCommentThreadProps>): Promise<CreateCommentThreadResult> => {
    return fetch(`/comments/${props.target}/threads?app_group_id=${props.appGroupId}`, "POST", {
      sub_target: props.subtarget,
      message: props.message,
    });
  }
);
